module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion3_m.23e47e6e3bda60d4a55c8ceb54252fbd.png";